import { scenes } from "../scenes";
import { Scene, Choice } from "../models";

export class ShibariLobby extends Scene {
  title = "Office Building Lobby";
  image = require("@/images/Elevator_Lobby_Ground.png");
  get options(): any[] {
    return [
      new Choice("Read Sign", () => {
        this.audio = require("@/audio/Pandemic-105-Sonny-MP3.mp3");
        this.description =
          "SONNY YANG: The sign reads: “Dear valued employees and visitors, as our emergency stairwells are currently undergoing a deep cleaning procedure, kindly use the elevators to access the upper levels.";
      }),
      new Choice("Enter Elevator", async () => await this.navigate(scenes.Elevator())),
      new Choice("Leave", async () => await this.navigate(scenes.ShibariHQ())),
    ];
  }
}
export default new ShibariLobby();
